// Product_BrandList_Container.jsx
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { getDataFromAPI } from "../../../HandleAPICalls/actions";
import Product_BrandList_Component from "./component";

const Product_BrandList_Container = (props) => {
  const [loading, setLoading] = useState(false);
  const [productListData, setProductListData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');

  // Load initial data
  useEffect(() => {
    loadProducts();
  }, []);

  // Search functionality
  useEffect(() => {
    if (searchTerm.trim() === '') {
      setFilteredData(productListData);
    } else {
      const filtered = productListData.filter(brand => 
        brand.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        brand.id?.toString().includes(searchTerm)
      );
      setFilteredData(filtered);
    }
  }, [searchTerm, productListData]);

  const loadProducts = () => {
    setLoading(true);

    props.getDataFromAPI(
      `/dashboard/api/v5/brands/all`,
      "GET",
      undefined,
      (response) => {
        if (response) {
          setProductListData(response);
          setFilteredData(response);
        }
        setLoading(false);
      },
      (error) => {
        console.error("Failed to fetch products:", error);
        setLoading(false);
      }
    );
  };

  const handleCreateBrand = () => {
    // Navigate to create brand page
    console.log("Navigate to create brand");
  };

  return (
    <Product_BrandList_Component
      products={filteredData}
      loading={loading}
      searchTerm={searchTerm}
      setSearchTerm={setSearchTerm}
      onCreateBrand={handleCreateBrand}
      onRefresh={loadProducts}
    />
  );
};

export default connect(null, { getDataFromAPI })(Product_BrandList_Container);